/**
 * Generate unique uuid based on timestamp
 * @returns generated string uuid
 */
const createUUID = () => {
  const timestamp = Date.now()

  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const random = (timestamp + Math.random() * 16) % 16 | 0
    return (c == 'x' ? random : (random & 0x3) | 0x8).toString(16)
  })

  return uuid
}

export { createUUID }
